
import isExperienceEditor from '@utils/is-experience-editor';

var VCA = VCA || {};

VCA.Accordion = (function ($) {

    function init() {
        if ($('.js-accordion-section').length) {
            $('.js-accordion-section').each(function() {
                var item = $(this);
                if(item.find('.accordion__item').length == 0 && !isExperienceEditor) {
                    item.hide();
                 }
            })
        }
    }

    return {
        init: init
    };

})(jQuery);

$(function () {
    VCA.Accordion.init();
});